// extracted by mini-css-extract-plugin
export default {"info_container":"introduction_info_container__9Erfh","contact_img":"introduction_contact_img__C4ZoG","contact_container":"introduction_contact_container__wGY-y"};